import React from "react";
import BaseMainContainer from "../../sisu/layout/BaseMainContainer.sisu";

const NeoMainContainer = (props) => {
  return (
    <BaseMainContainer custom="main-container" {...props}/>);
};

export default NeoMainContainer;